export default class Utils{
    static promisify(f, manyArgs = false) {
        //console.log(f);
        return  (...args) => {
            return new Promise((resolve, reject) => {
                function callback(err, ...results) { // our custom callback for f
                    if (err) {
                    reject(err);
                    } else {
                    // resolve with all callback results if manyArgs is specified
                    resolve(manyArgs ? results : results[0]);
                    }
                }

                args.push(callback);
                //console.log(f);
                f.call(this, ...args);
            });
        };
    }

    static arrayBufferToBase64( buffer ) {
        var binary = '';
        var bytes = new Uint8Array( buffer );
        var len = bytes.byteLength;
        for (var i = 0; i < len; i++) {
            binary += String.fromCharCode( bytes[ i ] );
        }
        return window.btoa( binary );
    }
}